import http from "../http-common";
import httpFile from "../http-multipart";
import httpCommon from "../http-common";
class AlbumService {
  searchAlbum(maxPageItem, pageNumber, timeAlbumSearch, idGrade, idClass, albumType) {
    return http.get(`/album?maxPageItem=${maxPageItem}&pageNumber=${pageNumber}&timeAlbumSearch=${timeAlbumSearch}&idGrade=${idGrade}&idClass=${idClass}&albumType=${albumType}`);
  }
  searchalbumNew(pageNumber, maxPageItem, timeStart, timeEnd, idGrade, idClass, albumType, status) {
    return http.get(`/album/search?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&timeStart=${timeStart}&timeEnd=${timeEnd}&idGrade=${idGrade}&idClass=${idClass}&albumType=${albumType}&hideAndShow=${status}`);
  }
  searchalbumNewWeb(pageNumber, maxPageItem, date, albumType) {
    return http.get(`/parent/album?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&date=${date}&albumType=${albumType}`);
  }
  getAlbumByIdWeb(id) {
    return http.get(`/parent/album/detail/${id}`);
  }
  getAlbumById(id) {
    return http.get(`/album/${id}`);
  }
  getTotalItems() {
    return http.get(`/album/total-rows`);
  }
  deletePicture(id) {
    return http.delete(`/album/picture/${id}`);
  }
  deleteAlbum(id) {
    return http.delete(`/album/album/${id}`);
  }
  dowloadAlbum1(id) {
    return http.get(`/album/download/${id}`);
  }
  dowloadAlbumWeb(id) {
    return http.get(`/parent/album/download/${id}`);
  }
  deleteMultiAlbum(data) {
    return http.put(`/album/multi-album`,data);
  }
  updateApprovePicture(id, data) {
    return http.put(`/album/approve/${id}`, data)
  }
  updateAllApprovePicture(id) {
    return http.put(`/album/approve-all/${id}`)
  }
  updateMultiApproveAlbum(data) {
    return http.put(`/album/approve-multi-album`, data)
  }
  updateMultiUnApproveAlbum(data) {
    return http.put(`/album/unapprove-multi-album`, data)
  }
  updateAlbumUpload(formData) {
    return httpFile.post(`/album/edit`, formData);
  }
  updateAlbumUploadNew(formData) {
    return httpFile.post(`/album/edit-new`, formData);
  }
  createAlbumUpload(formData) {
    return httpFile.post(`/album`, formData);
  }
  createAlbumUploadNew(formData) {
    return httpFile.post(`/album/create-new`, formData);
  }
  getSyConfigPicture(){
    return http.get(`/album/search/sys_config_picture`)
  }
  /**
   * Hoành đánh dấu: Thêm Api lấy số lượng ảnh tối đa khi đăng Album
   */

  getAlbumMaxNumber() {
    return http.get(`/album/getAlbumMaxNumber`);
  }

  // Thống kê album
  getAlbumStatisticsToday() {
    return http.get(`/album/statistics/today`);
  }
  getAlbumStatisticsRange(startDate, endDate) {
    return http.get(`/album/statistics/range?startDate=${startDate}&endDate=${endDate}`);
  }

  /**
   * Đặt ảnh đại diện cho album
   */
  setUpAvatarAlbum(id){
    return http.get(`/album/update/avatar/album/${id}`)
  }

  savePictureAlbum(formData) {
    return httpFile.post('/album/save/picture', formData)
  }

  getSizeListImage() {
    return httpCommon.get('/album/system/size-list-image')
  }
}
export default new AlbumService();